import React from "react";

import {
  SessionCardsGrid,
  SectionHeaderTitle,
  SectionTitleTypography,
  StepTypography,
  ShowSelectionContainer,
} from "./ShowSelection.styles";
import { MeshColours, ShowCard } from "..";
import { Show } from "src/models/audience/Show";

export interface CustomShowSelectionProps {
  shows: Show[] | null;
  onShowCardClickHandler: Function;
}

const colorArray: MeshColours[] = [
  "pink-blue-teal",
  "teal-green",
  "blue-green-teal",
  "red-green-teal",
  "orange-pink",
  "pink-purple-green",
];

export const ShowSelection = ({
  shows,
  onShowCardClickHandler,
  ...rest
}: CustomShowSelectionProps) => {
  return (
    <ShowSelectionContainer>
      <SectionHeaderTitle>
        <StepTypography>Our Shows</StepTypography>
        <SectionTitleTypography>Select a Show</SectionTitleTypography>
      </SectionHeaderTitle>

      <SessionCardsGrid>
        {shows === null ? (
          <StepTypography>Loading...</StepTypography>
        ) : shows.length === 0 ? (
          <StepTypography data-cy="no-show-found">No shows found </StepTypography>
        ) : (
          shows.map((show, index) => (
            <ShowCard
              key={`show-${show.id}`}
              show={show}
              handleClick={() => onShowCardClickHandler(show)}
              colour={colorArray[index % colorArray.length]}
            />
          ))
        )}
      </SessionCardsGrid>
    </ShowSelectionContainer>
  );
};

export interface ShowSelectionProps
  extends React.ComponentProps<typeof ShowSelection> {
  as?: React.ElementType;
}

ShowSelection.displayName = "ShowSelection";
